import type { ReportHistoryEntryType } from '@api';
import {
  ReportVariantUnionType,
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { useReportHistoryTableColumns } from './hooks';

type ReportHistoryTablePropsType = {
  variant: ReportVariantUnionType;
  entries: ReportHistoryEntryType[];
  canReview: boolean;
  pendingEntryId: string | undefined;
  onMarkAsReviewed: (entryId: string) => void;
};

export const ReportHistoryTable: React.FC<ReportHistoryTablePropsType> = ({
  variant,
  entries,
  canReview,
  pendingEntryId,
  onMarkAsReviewed,
}) => {
  const { t } = useTranslation();
  const { columns } = useReportHistoryTableColumns({
    canReview,
    pendingEntryId,
    onMarkAsReviewed,
  });

  return (
    <TouringCard data-testid="report-history-container">
      <TouringCardHeader>
        <TouringCardTitle>{t('REPORTS.HISTORY.TITLE')}</TouringCardTitle>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<ReportHistoryEntryType>
          records={entries}
          columns={columns}
          noRecordsText={t(`REPORTS.HISTORY.EMPTY.${variant}`)}
          withTableBorder={false}
          withColumnBorders={false}
          highlightOnHover={false}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
